export class ChainDef {
  constructor () {
    this.length = 0
    this.pos = { x: 0, y: 0 }
    this.limbColor = 0xffffff
    this.scalingFunction = (i) => { return { x: 0.6, y: 0.6 } }
    this.colorFunction = (i) => { return i === this.length - 1 ? this.handColor : this.limbColor }
    this.handColor = 0xffffff
    this.limbImage = 'limb'
    this.handImage = 'limb'
    this.decreaseFriction = true
    this.dist = 8
    this.isNewImage = false
  }
}

export class AnimalDef {
  constructor () {
    this.isNewImage = false
    this.imageName = 'cat'
    this.bodyColor = 0xffffff
    this.hasLegs = true
    this.hasArms = true

    this.tailInfos = [new ChainDef()]
    this.leftArmInfo = new ChainDef()
    this.rightArmInfo = new ChainDef()
    this.leftLegInfo = new ChainDef()
    this.rightLegInfo = new ChainDef()
    this.sendTailToBack = false
    this.hasTail = true
    this.stiffenNeck = false
    this.tailInFront = false
    this.bodyInFront = false
    this.hasEars = false
    this.leftEarInfo = new ChainDef()
    this.rightEarInfo = new ChainDef()
  }

  createAnimal (x, y, player, scene) {
    this.scene = scene
    this.player = player
    // if (this.isNewImage) {
    // this.player.image = this.scene.matter.add.image(x, y, this.imageName)
    // } else {
    this.player.image = this.scene.matter.add.image(x, y, 'images', this.imageName)
    // }
    this.player.image.setTint(this.bodyColor)
  }

  createTails (x, y) {
    this.player.leftArmIndx = 0
    this.player.tailIndx = 0
    this.player.tailLength = this.tailInfos[0].length
    this.player.armLength = this.leftArmInfo.length
    this.player.legLength = this.hasLegs ? this.leftLegInfo.length : 0

    if (this.hasTail) {
      if (!this.tailInFront) {
        for (let i = 0; i < this.tailInfos.length; i++) {
          this.addChain(x, y, this.tailInfos[i])
          this.player.leftArmIndx += this.tailInfos[i].length
        }
      }
    }

    this.player.rightArmIndx = this.player.leftArmIndx + this.player.armLength
    this.player.leftLegIndx = this.player.rightArmIndx + this.player.armLength
    this.player.rightLegIndx = this.player.leftLegIndx + this.player.legLength

    this.addChain(x, y, this.leftArmInfo)
    this.addChain(x, y, this.rightArmInfo)
    if (this.hasLegs) {
      this.addChain(x, y, this.leftLegInfo)
      this.addChain(x, y, this.rightLegInfo)
    }

    if (this.hasTail && this.tailInFront) {
      for (let i = 0; i < this.tailInfos.length; i++) {
        this.addChain(x, y, this.tailInfos[i])
      }

      this.player.tailIndx = this.player.rightLegIndx + this.player.legLength
    }

    if (this.sendTailToBack) {
      for (var i = this.player.leftArmIndx - 1; i >= this.player.tailIndx; i--) {
        this.player.sendToBack(this.player.tails[i])
      }
    }

    if (this.hasEars) {
      this.addChain(x, y, this.leftEarInfo)
      this.addChain(x, y, this.rightEarInfo)
    }

    if (this.bodyInFront) {
      this.player.bringToTop(this.player.image)
    }
  }

  addChain (x, y, info) {
    var link
    var constr
    var prev = this.player.image
    for (var i = 0; i < info.length; i++) {
      // 1. image:
      if (i === info.length - 1) {
        // if (info.isNewImage) {
        // link = this.scene.matter.add.image(0, y, info.handImage)
        // } else {
        link = this.scene.matter.add.image(0, y, 'images', info.handImage)
        // }
      } else {
        link = this.scene.matter.add.image(0, y, 'images', info.limbImage)
      }

      // color:
      link.setTint(info.colorFunction(i))

      // 2. scale:
      const scale = info.scalingFunction(i)
      link.setScale(scale.x, scale.y)

      // 3. physics:
      link.setCircle(1)
      this.player.add(link)
      if (info.decreaseFriction) {
        link.setFrictionAir(0.4 - (i * (0.4 / info.length)))
      } else {
        link.setFrictionAir(0.4)
      }
      link.setMass(0.0000000000001)
      var dist = info.dist
      if (i === 0) {
        constr = this.scene.matter.add.constraint(prev, link, 8, 1, { pointA: info.pos })
      } else {
        constr = this.scene.matter.add.constraint(prev, link, dist, 1)
      }

      // 4. finalise:
      link.setCollisionCategory(this.scene.collisionCategory4)
      link.setCollidesWith(this.scene.collisionCategory4)
      this.player.constraints.push(constr)
      this.player.tails.push(link)
      prev = link
    }
  }
}
